import { createSlice } from "@reduxjs/toolkit";

const projectSummaryLive = createSlice({
  name: "projectSummaryLive",
  initialState: {
    data: [],
    errorMessage: "",
    page: 0,
    itemsPerPage: 10,
    status: "",
    projectSummaryId: "",
    exportData: [],
  },

  reducers: {
    setProjectSummaryLive(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setProjectSummaryLive } = projectSummaryLive.actions;
export default projectSummaryLive.reducer;
